import PropTypes from "prop-types";
import HealthScoreGauge from "./charts/HealthScoreGauge";

const getHealthMeta = (value) => {
  if (value <= 40) return { color: "#f44336", label: "Poor" };
  if (value <= 70) return { color: "#ff9800", label: "Needs Work" };
  return { color: "#4caf50", label: "Healthy" };
};

function DirectoryHealthCard({
  score,
  listingsVolume,
  claimRate,
  premiumConversion,
  visibility,
  activity,
}) {
  const scoreMeta = getHealthMeta(score);

  const metrics = [
    { label: "Listings Volume", value: listingsVolume },
    { label: "Claim Rate", value: claimRate },
    { label: "Premium Conversion", value: premiumConversion },
    { label: "Visibility", value: visibility },
    { label: "Activity", value: activity },
  ];

  return (
    <section className="sd-card">
      <h3 className="sd-section-title">Directory Health Score</h3>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "120px",
          }}
        >
          <HealthScoreGauge score={score} color={scoreMeta.color} />
          <div className="sd-directory-health__score">
            {score} / 100
          </div>
          <div className="sd-directory-health__label" style={{ color: scoreMeta.color }}>
            {scoreMeta.label}
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            {metrics.map((item, index) => {
              const meta = getHealthMeta(item.value);
              return (
                <div key={index}>
                  <div className="sd-directory-health__metric-row">
                    <span>{item.label}</span>
                    <span>{item.value}%</span>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "6px",
                      borderRadius: "6px",
                      backgroundColor: "#e0e0e0",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${item.value}%`,
                        height: "100%",
                        borderRadius: "6px",
                        backgroundColor: meta.color,
                        transition: "width 1s ease-in-out",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

DirectoryHealthCard.propTypes = {
  score: PropTypes.number.isRequired,
  listingsVolume: PropTypes.number,
  claimRate: PropTypes.number,
  premiumConversion: PropTypes.number,
  visibility: PropTypes.number,
  activity: PropTypes.number,
};

export default DirectoryHealthCard;

